export namespace Message {
    export enum MessageStatus {
        UnRead = 0,
        Read = 1,
        All = -1,
    }

    /** 消息类型 */
    export enum MessageType {
        /** 提醒事项 */
        Reminder = 100,
        /** 评论 */
        SNS = 200,
        /** 自动化任务异常 */
        Automation_Task_Exception = 301,
        /** 自动化任务延时 */
        Automation_Task_Delay = 302,
        /** 自动化文本消息 */
        Automation_Text = 303,
        /** 自动化链接消息 */
        Automation_Link = 304,
        /** 企业互联 */
        AssociatedOrganization = 400,
        /** 插件 */
        Plugin = 500,
        /** 插件-短信 */
        Plugin_SMS = 501,
        /** 插件-邮件 */
        Plugin_Email = 502,
        /** 插件-群通知 */
        Plugin_Robot = 503,
        /** 插件-OCR */
        Plugin_OCR = 504,
        /** 平台公告 */
        Announcement = 600,
    }

    export enum LinkMessageValueType {
        /** 自定义链接 */
        Fixed = 'Fixed',
        /** 查看数据链接 */
        ViewDataUrl = 'ViewDataUrl',
        /** 新增数据链接 */
        CreateDataUrl = 'CreateDataUrl',
    }

    export enum MessageMenuType {
        /** 提醒事项 */
        Reminder = 0,
        /** 应用消息 */
        ApplicationMessage = 1,
        /** 系统消息 */
        SystemMessage = 2,
        /** 平台公告（运营类的消息） */
        OperationMesssge = 3,
    }

    /** 消息状态 */
    export interface MessageMenuOption {
        title: string;
        type: MessageMenuType;
        icon: string;
        count: string;
    }

    /** 消息状态 */
    export interface MessageStatusOption {
        text: string;
        value: MessageStatus;
    }

    export interface IMessageItem {
        /** 消息类目 */
        category: MessageMenuType;
        /** 消息内容 */
        content: string;
        /** 时间 */
        createdTime: string;
        /** 链接 */
        link: string | null;
        /** 消息ID */
        messageId: string;
        /** 额外的参数 */
        params: Record<string, unknown>;
        /** 表单编码 */
        schemaCode: string;
        /** 表单名称 */
        schemaName: string;
        /** 应用名称 */
        appName: string;
        /** 应用编码 */
        appCode: string;
        /** 发送者ID */
        senderId: string;
        /** 状态 */
        status: MessageStatus;
        /** 标题 */
        title: string;
        /** 类型 */
        type: MessageType;
    }

    export namespace Request {
        /** 消息列表入参 */
        export interface IMessageListModel {
            /** 页码 */
            pageIndex: number;
            /** 页数 */
            pageSize: number;
            /** 消息类型 */
            categories?: MessageMenuType[];
            /** 消息状态 */
            status?: MessageStatus;
            /** 消息来源 */
            appCode?: string;
        }

        /** 标记消息为已读入参 */
        export interface IMessageReadModel {
            /** 消息Id */
            messageId?: string;
            /** 消息类型 */
            categories?: MessageMenuType[];
            /** 消息来源 */
            appCode?: string;
        }
    }

    export namespace Response {
        /** 消息列表返回参数 */
        export interface IMessageListModel {
            /** 未读消息总数 */
            unReadCount: number;
            data: IMessageItem[];
        }

        /** 未读消息总数返回参数 */
        export interface IMessageCountModel {
            category: MessageMenuType;
            count: number;
        }
    }
}
